import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router';

import paths from '@/lib/paths';

import type { RiskObjectMinimal } from '../../types';
import RiskObjectIcon from '../RiskObjectIcon';

type Props = {
  riskObject: RiskObjectMinimal;
};

export default function RiskObjectItem({ riskObject }: Props) {
  const { t } = useTranslation();

  return (
    <Link
      to={generatePath(paths.riskObjects.detail, {
        id: riskObject.risk_object_id,
      })}
      className="shadow-card flex flex-col rounded-lg border p-2"
    >
      <span className="flex items-center gap-1 leading-tight">
        <RiskObjectIcon
          type={riskObject.risk_object_type}
          className="size-3.5"
        />

        <span className="text-sm leading-tight">{riskObject.name}</span>
      </span>

      <span className="text-muted-foreground text-xs">
        {t(`RISK_OBJECT_TYPE_${riskObject.risk_object_type?.toUpperCase()}`)}
      </span>
    </Link>
  );
}
